export default {
    cz: {
        order: 'Objednat',
    },
    sk: {
        order: 'Objednať',
    },
}
